// extracted by mini-css-extract-plugin
export default {"counter-inline-custom-vars":"counter-inline-custom-vars__HSSiW","counter-inline-custom-colors":"counter-inline-custom-colors__WjkPI"};